import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-223aca9c")

_pushScopeId("data-v-223aca9c")
const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Checkout", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Benefits of the Booking Fee Service:", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: "/assets/icon/save-time.svg",
  alt: "save time"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Save time")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Let “Party Place” send your party booking details to your chosen suppliers direct from your “My Account”, all in one go! ")
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: "/assets/icon/easy-to-track.svg",
  alt: "save time"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Easy to track")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Your Unique Party Place reference number helps you and your chosen suppliers identify your party details quickly and easily, no messing around looking through multiple emails back and forth. ")
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: "/assets/icon/status-update.svg",
  alt: "save time"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Status update")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Use the Party Checklist feature to keep track of supplier confirmations or rejections or request for more information. Quick look dashboard for supplier status. ")
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: "/assets/icon/party-gift.svg",
  alt: "save time"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Party Gift")
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Receive our complimentary free party pack of balloons, poppers, stickers etc.. Let everyone know where your party is happening! ")
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: "/assets/icon/share-the-love.svg",
  alt: "save time"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Share the love")
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Help us fund the sponsoring of party events for those who “deserve a party”, i.e. those less fortunate that you and who could really benefit for the experience, from the younger to the older members of our community -lets make Jersey a happier place! ")
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: "/assets/img/Party-Place-Goodies-Scene.svg",
  alt: "party pack",
  style: {"width":"100%"}
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Order Summary")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Party Plan + Party Pack")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("£4.00")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Where would you like your party pack to be sent? ")
const _hoisted_28 = { class: "detail-item-container" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("First name*")
const _hoisted_30 = { class: "detail-item-container" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Last name")
const _hoisted_32 = { class: "detail-item-container" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Address line 1*")
const _hoisted_34 = { class: "detail-item-container" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Address line 2")
const _hoisted_36 = { class: "detail-item-container" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Address line 3")
const _hoisted_38 = { class: "detail-item-container" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Parish*")
const _hoisted_40 = { class: "detail-item-container" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Post code*")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Confirm Address ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Thank you for confirming your address ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Choose Your Payment Method ")
const _hoisted_45 = /*#__PURE__*/_createVNode("img", {
  src: "/assets/img/paypal.svg",
  alt: "PayPal"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("img", {
  src: "/assets/img/citypay.png",
  alt: "CityPay"
}, null, -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("img", {
  class: "mastercard",
  src: "/assets/img/mastercard.png",
  alt: "Mastercard"
}, null, -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("img", {
  class: "visa",
  src: "/assets/img/visa.png",
  alt: "Visa"
}, null, -1)
const _hoisted_49 = { ref: "paypal" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Confirm & Pay Now ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_Header),
      _createVNode(_component_ion_content, { class: "checkout-steps-page" }, {
        default: _withId(() => [
          _createVNode(_component_ion_grid, { class: "pad-bot-lg" }, {
            default: _withId(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, {
                    sizeXl: "6",
                    sizeLg: "8",
                    sizeMd: "10",
                    sizeSm: "12",
                    class: "white-bg no-pad border-radius-sm"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_grid, { class: "account-page edit-party-header no-pad" }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, { class: "\n                    step-header\n                    ion-align-items-center\n                    ion-justify-content-center\n                    ion-padding\n                    ion-text-center\n                  " }, {
                                default: _withId(() => [
                                  _hoisted_2
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-text-center ion-text-sm-start ion-padding light-bg" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, {
                                sizeXs: "12",
                                sizeSm: "2",
                                class: "ion-text-center"
                              }, {
                                default: _withId(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_text, {
                                    color: "primary",
                                    class: "benefit-headings"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_5,
                                  _createVNode(_component_ion_text, { class: "benefits-description" }, {
                                    default: _withId(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-text-center ion-text-sm-start ion-padding" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, {
                                sizeXs: "12",
                                sizeSm: "2",
                                class: "ion-text-center"
                              }, {
                                default: _withId(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_text, {
                                    color: "primary",
                                    class: "benefit-headings"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_9,
                                  _createVNode(_component_ion_text, { class: "benefits-description" }, {
                                    default: _withId(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-text-center ion-text-sm-start ion-padding light-bg" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, {
                                sizeXs: "12",
                                sizeSm: "2",
                                class: "ion-text-center"
                              }, {
                                default: _withId(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_text, {
                                    color: "primary",
                                    class: "benefit-headings"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_12
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_13,
                                  _createVNode(_component_ion_text, { class: "benefits-description" }, {
                                    default: _withId(() => [
                                      _hoisted_14
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-text-center ion-text-sm-start ion-padding" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, {
                                sizeXs: "12",
                                sizeSm: "2",
                                class: "ion-text-center"
                              }, {
                                default: _withId(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_text, {
                                    color: "primary",
                                    class: "benefit-headings"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_16
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_17,
                                  _createVNode(_component_ion_text, { class: "benefits-description" }, {
                                    default: _withId(() => [
                                      _hoisted_18
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-text-center ion-text-sm-start ion-padding light-bg" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, {
                                sizeXs: "12",
                                sizeSm: "2",
                                class: "ion-text-center"
                              }, {
                                default: _withId(() => [
                                  _hoisted_19
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_text, {
                                    color: "primary",
                                    class: "benefit-headings"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_20
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_21,
                                  _createVNode(_component_ion_text, { class: "benefits-description" }, {
                                    default: _withId(() => [
                                      _hoisted_22
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, null, {
                            default: _withId(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, null, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                default: _withId(() => [
                                  _createVNode("h3", null, [
                                    _createVNode(_component_ion_text, { color: "primary" }, {
                                      default: _withId(() => [
                                        _hoisted_24
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-padding summary-row" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withId(() => [
                                  _hoisted_25
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, { class: "ion-text-right" }, {
                                default: _withId(() => [
                                  _hoisted_26
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (!_ctx.addressSuccess)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_ion_row, { class: "ion-padding-top ion-padding-horizontal" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                      default: _withId(() => [
                                        _createVNode("h3", null, [
                                          _createVNode(_component_ion_text, { color: "primary" }, {
                                            default: _withId(() => [
                                              _hoisted_27
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_row, { class: "ion-padding" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_col, {
                                      size: "12",
                                      sizeSm: "6"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("div", _hoisted_28, [
                                          _createVNode(_component_ion_label, { class: "detail-label" }, {
                                            default: _withId(() => [
                                              _hoisted_29
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_input, {
                                            class: "detail-input",
                                            type: "text",
                                            placeholder: "First name",
                                            modelValue: _ctx.address.firstName,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.address.firstName = $event))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_col, {
                                      size: "12",
                                      sizeSm: "6"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("div", _hoisted_30, [
                                          _createVNode(_component_ion_label, { class: "detail-label" }, {
                                            default: _withId(() => [
                                              _hoisted_31
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_input, {
                                            class: "detail-input",
                                            type: "text",
                                            placeholder: "Last name",
                                            modelValue: _ctx.address.lastName,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.address.lastName = $event))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_col, { size: "12" }, {
                                      default: _withId(() => [
                                        _createVNode("div", _hoisted_32, [
                                          _createVNode(_component_ion_label, { class: "detail-label" }, {
                                            default: _withId(() => [
                                              _hoisted_33
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_input, {
                                            class: "detail-input",
                                            type: "text",
                                            placeholder: "Address line 1",
                                            modelValue: _ctx.address.addressLine1,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.address.addressLine1 = $event))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_col, { size: "12" }, {
                                      default: _withId(() => [
                                        _createVNode("div", _hoisted_34, [
                                          _createVNode(_component_ion_label, { class: "detail-label" }, {
                                            default: _withId(() => [
                                              _hoisted_35
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_input, {
                                            class: "detail-input",
                                            type: "text",
                                            placeholder: "Address line 2",
                                            modelValue: _ctx.address.addressLine2,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.address.addressLine2 = $event))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_col, { size: "12" }, {
                                      default: _withId(() => [
                                        _createVNode("div", _hoisted_36, [
                                          _createVNode(_component_ion_label, { class: "detail-label" }, {
                                            default: _withId(() => [
                                              _hoisted_37
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_input, {
                                            class: "detail-input",
                                            type: "text",
                                            placeholder: "Address line 3",
                                            modelValue: _ctx.address.addressLine3,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.address.addressLine3 = $event))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_col, {
                                      size: "12",
                                      sizeSm: "6"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("div", _hoisted_38, [
                                          _createVNode(_component_ion_label, { class: "detail-label" }, {
                                            default: _withId(() => [
                                              _hoisted_39
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_input, {
                                            class: "detail-input",
                                            type: "text",
                                            placeholder: "Parish",
                                            modelValue: _ctx.address.parish,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.address.parish = $event))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_col, {
                                      size: "12",
                                      sizeSm: "6"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("div", _hoisted_40, [
                                          _createVNode(_component_ion_label, { class: "detail-label" }, {
                                            default: _withId(() => [
                                              _hoisted_41
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_input, {
                                            class: "detail-input",
                                            type: "text",
                                            placeholder: "Post code",
                                            modelValue: _ctx.address.postcode,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.address.postcode = $event))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (Object.keys(_ctx.errors.address).length > 0)
                                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_col, null, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (msg, index) => {
                                              return (_openBlock(), _createBlock(_component_ion_text, {
                                                class: "ion-text-center",
                                                color: "danger",
                                                key: index
                                              }, {
                                                default: _withId(() => [
                                                  _createVNode("p", null, _toDisplayString(msg[0]), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_ion_row, { class: "ion-padding-vertical" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_button, {
                                          onClick: _ctx.confirmAddress,
                                          color: "success",
                                          disabled: _ctx.addressLoading
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_42
                                          ]),
                                          _: 1
                                        }, 8, ["onClick", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : (_openBlock(), _createBlock(_component_ion_row, {
                                key: 1,
                                class: "ion-padding-top ion-padding-horizontal"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                    default: _withId(() => [
                                      _createVNode("h3", null, [
                                        _createVNode(_component_ion_text, { color: "primary" }, {
                                          default: _withId(() => [
                                            _hoisted_43
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })),
                          (_ctx.showPayments)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_ion_row, { class: "ion-padding-top ion-padding-horizontal" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                      default: _withId(() => [
                                        _createVNode("h3", null, [
                                          _createVNode(_component_ion_text, { color: "primary" }, {
                                            default: _withId(() => [
                                              _hoisted_44
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_row, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_col, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_list, null, {
                                          default: _withId(() => [
                                            _createVNode(_component_ion_radio_group, { value: "payment-method" }, {
                                              default: _withId(() => [
                                                _createVNode(_component_ion_item, null, {
                                                  default: _withId(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withId(() => [
                                                        _hoisted_45
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_radio, {
                                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectPaymentMethod($event, 'paypal'))),
                                                      value: "paypal"
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_item, null, {
                                                  default: _withId(() => [
                                                    _createVNode(_component_ion_label, { class: "ion-flex ion-align-items-center" }, {
                                                      default: _withId(() => [
                                                        _hoisted_46,
                                                        _hoisted_47,
                                                        _hoisted_48
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_radio, {
                                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectPaymentMethod($event, 'citypay'))),
                                                      value: "citypay"
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_row, { class: "ion-padding-vertical" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                                      default: _withId(() => [
                                        _withDirectives(_createVNode("div", _hoisted_49, null, 512), [
                                          [_vShow, _ctx.paymentMethod === 'paypal']
                                        ]),
                                        _withDirectives(_createVNode(_component_ion_button, {
                                          onClick: _ctx.confirmPayment,
                                          color: "success",
                                          disabled: _ctx.paymentLoading
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_50
                                          ]),
                                          _: 1
                                        }, 8, ["onClick", "disabled"]), [
                                          [_vShow, _ctx.paymentMethod === 'citypay']
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})